import type { V2DocumentOwnerTypeInput } from '@idc-forms/schemas/api-v2/admin-documents'

/**
 * Los dueños del eje polimórfico (ADR 0022, capa 2). El tipo viene del contrato: si
 * el backend agrega un nivel, esto deja de compilar donde falte cubrirlo, que es
 * justo lo que se quiere.
 */
export type DocumentOwnerType = V2DocumentOwnerTypeInput

/** Los CUATRO niveles de catálogo, los únicos que hoy tienen pestaña de cartapacio. */
export const CATALOG_OWNER_TYPES = ['society', 'project', 'type-property', 'property'] as const

export type CatalogOwnerType = (typeof CATALOG_OWNER_TYPES)[number]

/**
 * Cómo se nombra al dueño en el copy de la pestaña. Se usa en las frases que explican
 * el alcance de publicar, y ahí el nivel importa: publicar en una sociedad llega a los
 * clientes de todas sus propiedades, y en un inmueble sólo a su comprador.
 */
export const CATALOG_OWNER_LABEL: Record<CatalogOwnerType, string> = {
  society: 'la sociedad',
  project: 'el proyecto',
  'type-property': 'el subtipo',
  property: 'el inmueble'
}

/**
 * A quién le llega lo que se publica en cada nivel. Es la única diferencia real entre
 * las cuatro pestañas, y va en el diálogo de publicar: el curador tiene que leer el
 * alcance ANTES de confirmar, no descubrirlo después.
 */
export const CATALOG_PUBLISH_REACH: Record<CatalogOwnerType, string> = {
  society: 'todos los clientes de todas las propiedades de esta sociedad',
  project: 'todos los clientes de este proyecto',
  'type-property': 'todos los clientes de los inmuebles de este subtipo',
  property: 'los clientes de este inmueble'
}
